import { useContext } from "react";
import axios from "axios";
import useSWR from "swr";
import { AuthContext } from "../../../context/AuthContext";
import { ADMIN_API_URL } from "../../../utils/env";
import { makerEnvironment } from "../environment";
import { MakerObservability, verifyObservability } from "./types";

export function useMakerObservability(hour = "") {
  const { tokenId, queryConfig } = useContext(AuthContext);
  const url = ADMIN_API_URL(
    `makers/observability${hour ? `?hour=${encodeURIComponent(hour)}` : ""}`
  );
  return useSWR<MakerObservability>(
    makerEnvironment() && tokenId ? [url, tokenId] : null,
    async () => {
      const response = await axios.get(url, {
        ...queryConfig(),
        timeout: 30000,
      });
      if (response.status !== 200)
        throw new Error("Monitoring requires a successful HTTP 200 response.");
      const data = verifyObservability(response.data);
      if (hour && Date.parse(data.start) !== Date.parse(hour))
        throw new Error(
          "Monitoring returned a different hour. Refresh before using these results."
        );
      return data;
    },
    {
      refreshInterval: 10000,
      refreshWhenHidden: false,
      refreshWhenOffline: false,
      revalidateOnFocus: true,
      focusThrottleInterval: 10000,
      dedupingInterval: 5000,
      keepPreviousData: false,
      shouldRetryOnError: false,
    }
  );
}
